import styled, { css } from '@mint-lib/styled';

import { Box } from '@myn/mui';

const FormattingInputWrapper = styled(Box)<{
  $scale: number;
}>`
  ${({ $scale }) => css`
    height: 100%;
    width: 100%;
    & > div {
      height: 100%;
      width: 100%;
    }

    input {
      user-select: none;
      cursor: default;
      text-align: right;
      font-size: ${0.875 * $scale}rem;
      line-height: ${1.25 * $scale};
    }

    input:focus {
      text-align: left;
    }

    .MuiTextField-root {
      height: 100%;
      width: 100%;
    }

    .MuiInputBase-root {
      min-height: 0;
      height: 100%;
      background-color: inherit;
      cursor: default;
      box-shadow: none;
    }

    .Mui-disabled {
      background-color: transparent;
      box-shadow: none;
    }
  `}
`;

export default FormattingInputWrapper;
